import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { InlineSvgComponent } from '../inline-svg/inline-svg.component';

export type ButtonColors =
  | 'onLight'
  | 'onDark'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger';

export type ButtonSizes = 'smaller' | 'xsmall' | 'small' | 'medium' | 'large';

@Component({
  selector: 'ui-button',
  imports: [ CommonModule, InlineSvgComponent ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {

  /** Specifies the color theme of the button. */
  color = input<ButtonColors>('onLight');
  /** Specifies whether the button uses secondary styling. */
  secondary = input<boolean>(false);
  /** Defines the size of the button. */
  size = input<ButtonSizes>('medium');
  /** Determines if the button is disabled. */
  disabled = input<boolean>(false);
  /** Specifies if the button is in a loading state. */
  loading = input<boolean>(false);
  /** Allows the selection of an optional icon. */
  icon = input<string>();
  /** Indicates whether the button content is centered. */
  centered = input<boolean>(false);
  type = input<'button' | 'submit' | 'reset'>('button');

  cssClasses = computed(() => {
    const classes: Record<string, boolean> = {
      'is-centered': this.centered(),
      secondary: this.secondary(),
      loading: this.loading(),
      disabled: this.disabled(),
      [this.size()]: true,
      [this.color()]: true,
    };

    return classes;
  });
}
